import { intersectionObserverEmits, useIntersectionObserver } from "@/components/organisms/mixins/intersection-observer.mixin"

export const pushProductsBlockProps = () => ({
  products: {
    type: Array,
    required: true
  },
  label: {
    type: String,
    required: false
  },
  productSeparator: {
    type: Boolean,
    default: false,
    required: false
  },
  context: {
    type: String,
    required: false
  },
  recetteIndex: {
    type: Number,
    required: false,
    default: -1
  },
  pushTitle: {
    type: String,
    required: false,
    default: ""
  },
  cartContext: {
    type: String,
    required: false,
    default: ""
  },
  produitRecette: {
    type: Object,
    required: false,
    default: null
  },
  light: {
    type: Boolean,
    required: false,
    default: false
  },
  slidesOffset: {
    type: Number,
    required: false,
    default: null
  }
})

export const pushProductsBlockEmits = () => ([
  ...intersectionObserverEmits()
])

export const usePushProductsBlock = (props, context, carouselRef) => {
  const updated = ref(false);

  const { onIntersect } = useIntersectionObserver(context);

  const updateOnce = () => {
    if (updated.value) {
      return;
    }
    updated.value = true;
    carouselRef.value.update();
  }
  const getDiapoNumber = (index) => {
    const nb = index + 1;
    if (index < props.recetteIndex) {
      return nb;
    }
    return nb + 1;
  }

  return { updated, updateOnce, onIntersect, getDiapoNumber }
}